import React from "react";
import Activation from "../GeneralConfigC&C/Activation";
import LoyaltyAccount from "../GeneralConfigC&C/LoyaltyAccount";
import PaymentChoice from "../GeneralConfigC&C/PaymentChoice";
import SalesMethods from "../GeneralConfigC&C/SalesMethods";
import Options from "../GeneralConfigC&C/Options";
import Orders from "../GeneralConfigC&C/Orders/Orders";
import Schedule from "../GeneralConfigC&C/Schedule";
import AccountClient from "../Website/AccountClient/AccountClient";
import Divers from "../Website/Divers/Divers";
import { CoverPage } from "../Website/CoverPage";
import { AdvertisingScreen } from "../Application/AdvertisingScreen";
import { ShopSelection } from "../Application/ShopSelection";
import { ShopInformationPage } from "../Application/ShopInformationPage";
import { AppCoverPage } from "../Application/AppCoverPage";
import { Fidelity } from "../Application/Fidelity";
import { AppDivers } from "../Application/AppDivers";
import ShopPage from "../Website/shopPage/ShopPage";
import WebsiteShoPage from "../Shop/Website/WebsiteShoPage";
import Delivery from "../GeneralConfigC&C/Delivery";
import WebsiteAccountClient from "../Shop/Website/WebsiteAccountClient";
import WebsiteOrderTaking from "../Shop/Website/WebsiteOrderTaking";
import { Languages } from "../Website/Languages/index";
import ApplicationShopSelection from "../Shop/Application/ApplicationShopSelection";
import ApplicationShopInformationPage from "../Shop/Application/ApplicationShopInformationPage";
import ApplicationFidelity from "../Shop/Application/ApplicationFidelity";
import ApplicationCoverPage from "../Shop/Application/ApplicationCoverPage";
import { Payment } from "../Website/Payment";
import { WebsitePayment } from "../Shop/Website/WebsitePayment";
import { OrderTaking } from "../Website/OrderTaking";
import OptionsApk from "../Common/OptionsApk";
import { Forms } from "../Website/Forms";

interface SubTab {
    title: string;
    content: React.ReactNode;
    customClassName: string;
}

interface Tab {
    title: string;
    content: React.ReactNode;
    customClassName: string;
    subMenu?: SubTab[];
}
export function getTabs({ selectedRows, isLoading, template, t }: any): Tab[] {
    const tabs: Tab[] =
        selectedRows[0].subRows !== undefined
            ? [
                  {
                      title: t("Website"),
                      content: "",
                      customClassName: "",
                      subMenu: [
                          {
                              title: t("Cover page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <CoverPage />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_coverPage",
                          },
                          {
                              title: t("Shop page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <ShopPage />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_shopPage",
                          },
                          {
                              title: t("Order taking"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <OrderTaking />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_orderTaking",
                          },
                          {
                              title: t("Payment"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <Payment />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_payment",
                          },
                          {
                              title: t("Account Client"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <AccountClient />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_accountClient",
                          },
                          {
                              title: t("Divers"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <Divers />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_divers",
                          },
                          {
                              title: t("Language"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <Languages type="SiteWeb" />
                              ),
                              customClassName: "cac_sid_languages",
                          },
                          {
                              title: t("Forms"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <Forms />
                              ),
                              customClassName: "cac_sid_forms",
                          },
                      ],
                  },
                  {
                      title: t("Application"),
                      content: "",
                      customClassName: "",
                      subMenu: [
                          {
                              title: t("Advertising images"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <AdvertisingScreen />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_advertisingImages",
                          },
                          {
                              title: t("Shop selection"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <ShopSelection selectedRow={selectedRows} />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_shopSelection",
                          },
                          {
                              title: t("Shop information page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <ShopInformationPage />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_shopInformationPage",
                          },
                          {
                              title: t("Cover page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <AppCoverPage />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_appCoverPage",
                          },
                          {
                              title: t("Fidelity"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <Fidelity />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_fidelity",
                          },
                          {
                              title: t("Divers"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : template ? (
                                  <AppDivers />
                              ) : (
                                  <div>No template data available</div>
                              ),
                              customClassName: "cac_sid_appDivers",
                          },
                          {
                              title: t("Language"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <Languages type="Application" />
                              ),
                              customClassName: "cac_sid_appLanguages",
                          },
                      ],
                  },
              ]
            : [
                  {
                      title: t("General settings"),
                      content: "",
                      customClassName: "",
                      subMenu: [
                          {
                              title: t("Activation"),
                              content: (
                                  <Activation selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_activation",
                          },

                          {
                              title: t("Loyalty account"),
                              content: (
                                  <LoyaltyAccount selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_loyaltyAccount",
                          },
                          {
                              title: t("Payment choice"),
                              content: (
                                  <PaymentChoice selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_paymentChoice",
                          },
                          {
                              title: t("Sale mode"),
                              content: (
                                  <SalesMethods selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_modeOfSale",
                          },
                          {
                              title: t("Options"),
                              content: <Options selectedRows={selectedRows} />,
                              customClassName: "cac_sid_options",
                          },
                          {
                              title: t("Orders"),
                              content: <Orders selectedRows={selectedRows} />,
                              customClassName: "cac_sid_orders",
                          },
                          {
                              title: t("Delivery"),
                              content: <Delivery selectedRows={selectedRows} />,
                              customClassName: "cac_sid_delivery",
                          },
                          {
                              title: t("Schedule"),
                              content: <Schedule selectedRows={selectedRows} />,
                              customClassName: "cac_sid_hourly",
                          },
                      ],
                  },
                  {
                      title: t("Website"),
                      content: "",
                      customClassName: "",
                      subMenu: [
                          {
                              title: t("Shop page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <WebsiteShoPage selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_websiteShoPage",
                          },
                          {
                              title: t("Order taking"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <WebsiteOrderTaking
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName: "cac_sid_websiteOrderTaking",
                          },
                          {
                              title: t("Payment"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <WebsitePayment selectedRows={selectedRows} />
                              ),
                              customClassName: "cac_sid_websitePayment",
                          },
                          {
                              title: t("Account Client"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <WebsiteAccountClient
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName: "cac_sid_websiteAccountClient",
                          },
                          {
                              title: t("Options"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <OptionsApk
                                      selectedRows={selectedRows}
                                      type="SiteWeb"
                                  />
                              ),
                              customClassName: "cac_sid_optionsApk",
                          },
                      ],
                  },
                  {
                      title: t("Application"),
                      content: "",
                      customClassName: "",
                      subMenu: [
                          {
                              title: t("Shop selection"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <ApplicationShopSelection
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName:
                                  "cac_sid_applicationShopSelection",
                          },
                          {
                              title: t("Shop information page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <ApplicationShopInformationPage
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName:
                                  "cac_sid_applicationShopInformationPage",
                          },
                          {
                              title: t("Cover page"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <ApplicationCoverPage
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName: "cac_sid_applicationCoverPage",
                          },
                          {
                              title: t("Fidelity"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <ApplicationFidelity
                                      selectedRows={selectedRows}
                                  />
                              ),
                              customClassName: "cac_sid_applicationFidelity",
                          },
                          {
                              title: t("Options"),
                              content: isLoading ? (
                                  <div>Loading...</div>
                              ) : (
                                  <OptionsApk
                                      selectedRows={selectedRows}
                                      type="Application"
                                  />
                              ),
                              customClassName: "cac_sid_appOptionsApk",
                          },
                      ],
                  },
              ];

    return tabs;
}
